import { useState } from "react";
import { toast } from "sonner";
import { useAuth } from "../context/AuthContext";
import { formatApiError } from "../lib/roles";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter,
} from "./ui/dialog";
import { KeyRound, Loader2 } from "lucide-react";

export function ChangePasswordModal({ open, onClose }) {
  const { changePassword } = useAuth();
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);

  const reset = () => { setCurrent(""); setNext(""); setConfirm(""); };

  const save = async () => {
    if (next.length < 6) { toast.error("La nuova password deve avere almeno 6 caratteri"); return; }
    if (next !== confirm) { toast.error("Le due password non coincidono"); return; }
    setLoading(true);
    try {
      await changePassword(current, next);
      toast.success("Password aggiornata con successo!");
      reset();
      onClose();
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || "Errore");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={(o) => { if (!o) { reset(); onClose(); } }}>
      <DialogContent className="glass border-white/10" data-testid="change-password-modal">
        <DialogHeader>
          <DialogTitle className="font-display flex items-center gap-2">
            <KeyRound className="h-5 w-5 text-indigo-400" /> Cambia password
          </DialogTitle>
          <DialogDescription>Aggiorna la password del tuo account.</DialogDescription>
        </DialogHeader>
        <div className="space-y-3 py-1">
          <Input testid="cp-current" type="password" placeholder="Password attuale" value={current} onChange={setCurrent} />
          <Input testid="cp-new" type="password" placeholder="Nuova password (min. 6 caratteri)" value={next} onChange={setNext} />
          <Input testid="cp-confirm" type="password" placeholder="Conferma nuova password" value={confirm} onChange={setConfirm} />
        </div>
        <DialogFooter>
          <button onClick={() => { reset(); onClose(); }} className="px-4 py-2 rounded-xl bg-white/5 text-sm hover:bg-white/10">Annulla</button>
          <button data-testid="cp-save" onClick={save} disabled={loading}
            className="px-4 py-2 rounded-xl bg-indigo-500 text-white text-sm font-semibold hover:bg-indigo-400 transition-colors flex items-center gap-2 disabled:opacity-60">
            {loading && <Loader2 className="h-4 w-4 animate-spin" />} Salva
          </button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}

function Input({ testid, type, placeholder, value, onChange }) {
  return (
    <input data-testid={testid} type={type} placeholder={placeholder} value={value}
      onChange={(e) => onChange(e.target.value)}
      className="w-full bg-white/5 border border-white/10 rounded-xl px-3.5 py-2.5 text-sm focus:outline-none focus:border-indigo-400/50" />
  );
}
